import isSubclassOf from './isSubclassOf';
import isInstanceOf from './isInstanceOf';
/**
 * Returns true if the given object is either an instance or a
 * subclass of the given cls.
 *
 * @param  {*}  obj
 * @param  {Function}  cls
 * @return {Boolean}
 */
export default function isInstanceOrSubclassOf (obj, cls) {
  return isInstanceOf(obj, cls) || isSubclassOf(obj, cls);
}



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/isInstanceOrSubclassOf.js